module.exports = __webpack_public_path__ + "img/Portal_do_Servidor_Banner.6ce172f6.png";